import React from "react";
import Container from "../components/Container";
import TextSection from "../components/Home/TextSection";
import bg from "../assets/ResortGallery/RG3.jpg";
import Activities from "../components/Home/Activities";
import Explore from "../components/Home/Explore";
import Gallary from "../components/Home/Gallary";
import LogoStory from "../components/Home/LogoStory";
import OtherProperty from "../components/Home/OtherProperty";
import Testimonial from "../components/Home/Testimonias";
import TopBannerSection from "../components/TopBannerSection";
import MainScroll1 from "../components/Home/MainScroll1";
import MainScroll2 from "../components/Home/MainScroll2";
import MainScroll3 from "../components/Home/MainScroll3";
import HomeSuite from "../components/Home/HomeSuite";
import MobileScroll from "../components/Home/MobileScroll/MobileScroll";

const Home = () => {
  return (
    <Container>
      <TopBannerSection
        Image={bg}
        pageName={"EXPERIENCE"}
        Quote={"LUXURY,COMFORT & NATURE"}
        watchFlimBtn={true}
      />
      <TextSection />
      <MainScroll1 />
      <Gallary />
      <Testimonial />
      <Activities />
      <Explore />
      <LogoStory />
      <OtherProperty />
    </Container>
  );
};

export default Home;
